import React from 'react';

const Header = () => {
  return (
    <header className="relative py-12 overflow-hidden">
      <div className="animate-float absolute -top-20 -left-20 w-64 h-64 rounded-full bg-gold/5 blur-3xl"></div>
      <div className="animate-float absolute -bottom-20 -right-20 w-64 h-64 rounded-full bg-gold/5 blur-3xl"></div>
      
      <div className="container mx-auto text-center relative z-10">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 gold-gradient animate-glow">
          ✨ AYUNO COMPLETADO ✨
        </h1>
        <p className="text-xl md:text-2xl font-cinzel gold-gradient font-medium tracking-wider animate-pulse-slow mb-1">
          Altar Familiar de Avivamiento
        </p>
        <div className="w-32 h-1 bg-gradient-to-r from-gold-dark via-gold to-gold-light mx-auto rounded-full opacity-70 animate-pulse-slow"></div>
      </div>
      
      <div className="w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent mt-8"></div>
    </header>
  );
};

export default Header;
